module.exports = __webpack_public_path__ + "img/logo-um-fov-ang.501896c2.png";